let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7S32B")).then(() => parcelRequire('2S0Ei'));